var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from '@emotion/styled';
export var StyledCheckBox = styled.img(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: 15px;\n  height: 15px;\n  margin-top: 10px;\n  margin-right: 10px;\n"], ["\n  width: 15px;\n  height: 15px;\n  margin-top: 10px;\n  margin-right: 10px;\n"])));
var templateObject_1;
